import { mensagemDeErro } from '@/lib/erros';
import { toast } from '@/ui/primitives/aviso';

/** Campo opcional: string vazia no input vira `null` no contrato. */
export const nulo = { setValueAs: (valor: unknown) => (valor === '' ? null : valor) };

/** Executa a gravação com o aviso padrão de sucesso/erro. */
export async function gravar(acao: () => Promise<unknown>, mensagem: string): Promise<void> {
  try {
    await acao();
    toast.success(mensagem);
  } catch (erro) {
    toast.error(mensagemDeErro(erro));
  }
}
